import { Link } from 'react-router'

/** Brand mark (natural aspect, transparent). Default height 26px; pass a height class to resize. */
export function Logo({ className = 'h-[26px]' }: { className?: string }) {
  return (
    <img
      src="/logo-wide.png"
      alt="HR desk"
      width={213}
      height={128}
      draggable={false}
      className={`block w-auto select-none ${className}`}
    />
  )
}

export function Brand() {
  return (
    <Link
      to="/"
      className="flex min-w-0 items-center gap-2 rounded-ctl text-text no-underline"
      aria-label="HR desk, home"
    >
      <Logo className="h-5 shrink-0" />
      <span className="text-[17px] font-bold tracking-[-0.02em] whitespace-nowrap">HR desk</span>
    </Link>
  )
}
